import React, { FC } from 'react';
import Schema from '../../../../../../lib/paths/zwischenbericht_FULL_Paths.json';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../context/ApplicationContext';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
import { PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
const P = Schema.attributes;

const ZusammenArbeit: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title="Zusammenarbeit im Verbund" description={PLATZHALTER_TEXT} />
			<CreateForm
				formStruc={formStrucZusammenArbeit}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={readOnly}
			/>
		</>
	);
};
export default ZusammenArbeit;

export const formStrucZusammenArbeit = [
	{
		fields: [P.Zusammenarbeit_Im_Verbund_Beschreibung],
		userProps: { columnToDivide: 1 },
	},
];
